import { ListItemText } from "@mui/material";
import { Package } from "react-feather";
import { useTranslation } from "react-i18next";

import CheckBoxItemListItem from "../../../../components/checkboxItemList/CheckBoxItemListItem";
import { IDeliveryItem } from "../../../../models/deliveryItem";

interface CheckBoxDeliveryItemProps {
  deliveryItem: IDeliveryItem;
  selectedItems: IDeliveryItem[];
  handleChange: (
    event: React.ChangeEvent<HTMLInputElement>,
    item: IDeliveryItem,
  ) => void;
}

const CheckBoxDeliveryItem = (props: CheckBoxDeliveryItemProps) => {
  const { t } = useTranslation();
  const { deliveryItem, selectedItems, handleChange } = props;

  return (
    <CheckBoxItemListItem
      key={deliveryItem.id}
      item={deliveryItem}
      icon={<Package className="list-item-icon" size={24} />}
      checked={selectedItems.some(
        (selectedItem) => selectedItem.id === deliveryItem.id,
      )}
      handleChange={handleChange}
    >
      <ListItemText
        sx={{ wordBreak: "break-all" }}
        primary={`${deliveryItem.position} - ${deliveryItem.material} - ${deliveryItem.stockType} `}
        secondary={`${t("quantity")}: ${deliveryItem.quantity} ${deliveryItem.unitOfMeasurement}`}
      />
    </CheckBoxItemListItem>
  );
};

export default CheckBoxDeliveryItem;
